import React, { useState, useEffect } from 'react';
import {onResize} from "../../../../../../../wdh-foundation/wdh";
import TabsView from './views/tabs-view.jsx';
import DropdownView from './views/dropdown-view.jsx';
import SingleBlogCategory from './views/single-category-view.jsx';

const BlogCategories = ({ settings }) => {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    getCurrentCategoryFormUrl();
    onResize(() => {
      setIsDesktop(window.matchMedia('(min-width:992px)').matches);
    });
  }, []);
  const getCurrentCategoryFormUrl = () => {
    const currentUrl = window.location.pathname + window.location.search;
    settings.categories.forEach((category, index) => {
      const categoryUrl = category.pathname + category.search;
      if (decodeURIComponent(currentUrl) === decodeURIComponent(categoryUrl)) {
        setActiveCategoryIndex(index);
      }
    });
  };
  return (
    <div className="blog-categories-content">
      <div className={`blog-categories-content-wrapper ${settings.categories.length === 1 ? 'single-category' : ''} ${isDesktop && settings.categories.length < 7 ? '' : 'dropdown'}`}>
        {settings.categories.length === 1
          ?
          <SingleBlogCategory category={settings.categories[0]} />
          :
          isDesktop && settings.categories.length < 7
            ?
            <TabsView
              categories={settings.categories}
              activeCategoryIndex={activeCategoryIndex}
            />
            :
            <DropdownView
              categories={settings.categories}
              activeCategoryIndex={activeCategoryIndex}
            />
        }
      </div>
    </div>
  );
};

export default BlogCategories;
